@if (url) {
  <div class="dialog-content">
    <div mat-dialog-content>
      @if (mediaType == mediaTypeEnum.Image) {
        <img class="media-preview" [src]="url">
      }
      @if (mediaType == mediaTypeEnum.Video) {
        <video class="media-preview" [src]="url" controls></video>
      }
      @if (mediaType == mediaTypeEnum.Audio) {
        <audio [src]="url" controls></audio>
      }
    </div>
    <div mat-dialog-actions align="end">
      <button mat-button (click)="close()">{{ 'MODAL.CLOSE' | translate}}</button>
    </div>
  </div>
}